module.exports = __webpack_public_path__ + "static/media/0_2019_09_26.7dd8da7f.jpg";